import { CopyOneIcon } from "@/components/icons"
import { CONFIG_SETUP_ROUTES } from '@/features/design-system/routes'
import { useTranslation } from "@/hooks/useTranslation"
import { Box, Button, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import InputFile from "../../common/InputFile"

type Props = {}
const LayoutMain = (props: Props) => {
  const { t } = useTranslation()
  const [file, setFile] = useState();

  const navigate = useNavigate()

  const handClick = () => {
    navigate(CONFIG_SETUP_ROUTES.soilCommon.to)
  }
  const handleChangeImg = (e: any) => {
    setFile(e.target.files[0]);
  };

  return (
    <Stack alignItems="center">
      <Box sx={{ mt: "52px" }}>
        <Typography sx={{ color: "#5C5C5C", fontSize: "16px", fontWeight: "500" }}>Data 5 of 9</Typography>
        <Stack alignItems="center">
          <Typography sx={{ color: "#181818", fontSize: "18px" }}>{t('commonLabelsSoil')}</Typography>
        </Stack>
      </Box>
      <Stack sx={{ width: "366px", minHeight: "367px", mt: "82px" }}>
        <Box>
          <Typography sx={{ color: "#181818", fontSize: "16px", fontWeight: "500" }}>Step 1. Fill in your data in the CSV template</Typography>
          <Button sx={{
            backgroundColor: " rgba(4, 71, 68, 0.2)", borderRadius: "4px", height: "32px", width: "192px", mt: "10px", '&:hover': {
              backgroundColor: "rgba(4, 71, 68, 0.2)",
            },
          }}>
            <Stack direction="row" sx={{ color: "#004744" }}>
              <CopyOneIcon />
              <Typography sx={{ ml: "6px", p: "2px" }}>{t('commonActionsDownloadCsvTemplate')}</Typography>
            </Stack>

          </Button>
        </Box>
        <Box sx={{ mt: "50px" }}>
          <Typography sx={{ color: "#181818", fontSize: "16px", fontWeight: "500" }}>Step 2. Upload the CSV</Typography>
          <Box sx={{ mt: "12px" }} onClick={() => handClick()}>
            <InputFile
              title="Drag and drop CSV file here"
              file={file}
              accept={".csv"}
              handleChange={handleChangeImg}
              sx={{
                width: 439,
                height: 227,
                boxSizing: 'border-box',
              }}
            />
          </Box>
        </Box>
      </Stack>
    </Stack>
  )
}

export default LayoutMain